import { useEffect, useRef, useState } from "react";

const useTableCellWidths = (modalTable, tableData) => {
  const cellRefs = useRef([]);
  const [colWidths, setColWidths] = useState([]);

  useEffect(() => {
    if (!modalTable) {
      return;
    }

    const resizeObservers = [];

    const updateWidths = () => {
      const widths = cellRefs.current.map((ref) => ref?.offsetWidth || null);

      setColWidths(widths);
    };

    cellRefs.current.forEach((cell, index) => {
      if (cell) {
        const observer = new ResizeObserver(() => {
          updateWidths();
        });
        observer.observe(cell);
        resizeObservers[index] = observer;
      }
    });

    updateWidths();

    return () => {
      resizeObservers.forEach((observer) => observer.disconnect());
    };
  }, [modalTable, cellRefs?.current, tableData]);

  return { cellRefs, colWidths };
};

export default useTableCellWidths;
